import { combineReducers } from "redux";
import authenticationSlice from "./slices/authenticationSlice";
export default combineReducers({
  authenticationSlice,
});
